<template>
  <v-container
    style="height: 200px"
    class="overflow-y-auto overflow-x-hidden addresses"
  >
    <v-btn
      v-if="(editingAddressId === -1)"
      @click="newAddress()"
      fab
      dark
      small
      class="newAddress"
      color="primary"
    >
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>
    <v-row class="address_row defaultAddress" v-if="editingAddressId === 0">
      <Save
        :address="editingAddress"
        @saveAddress="saveAddress"
        @closed="closeEditAddress"
      />
    </v-row>
    <v-row
      v-for="(address, index) in addresses.slice().reverse()"
      :key="index"
      :class="{
        'address_row': true,
        'defaultAddress': (editingAddressId !== 0 && index === 0 && editingAddressId !== index + 1),
        'editingAddress': (editingAddressId === index + 1)
      }"
    >
      <Save
        v-if="(editingAddressId === index + 1)"
        :index="editingAddressId"
        :value="editingAddress"
        @saveAddress="saveAddress"
        @closed="closeEditAddress"
      />
      <div
        v-else
        class="address_row-inside"
      >
        <v-col cols="1" class="actions_col">
          <Actions
            :address="address"
            :isDefault="(index === 0)"
            @default="defaultAddress"
            @edit="editAddress"
            @delete="deleteAddress"
          />
        </v-col>
        <v-col v-if="(editingAddressId !== index + 1)" cols="11" class="address_col">
          <p><strong>{{ `${address.address} - ${address.num} ${(address.comp !== '' && address.comp !== undefined ? '(' + address.comp + ')' : '' )}` }}</strong></p>
          <p class="address_subtitle">{{ `${address.neighborhood} - ${address.city}/${address.state} ${(address.country !== '' && address.country !== undefined ? '- ' + address.country : '')}` }}</p>
          <p class="address_subtitle">{{ `${(address.cep !== '' && address.cep !== undefined ? address.cep : '')}` }}</p>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'
import addresses from '../mixins/addresses'

import Save from './addresses/Save'
import Actions from './addresses/Actions'

export default {
  mixins: [ appdata, addresses ],
  components: { Save, Actions },
  props: {
    addresses: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style scoped src="../styles/index.css"></style>
<style src="../styles/addresses.scss" lang="scss"></style>
